import {skipWaiting as workbox_core_skipWaiting} from 'C:/CODIGOFUENTES/LDCOM12_KIELSA/FUENTES_RQ-350-0391/INTERFACE/EXPRESS WEB/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-core/skipWaiting.mjs';
import {clientsClaim as workbox_core_clientsClaim} from 'C:/CODIGOFUENTES/LDCOM12_KIELSA/FUENTES_RQ-350-0391/INTERFACE/EXPRESS WEB/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/CODIGOFUENTES/LDCOM12_KIELSA/FUENTES_RQ-350-0391/INTERFACE/EXPRESS WEB/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








workbox_core_skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "./ClientApp/public/dist/0.3c0953cba7567a4d24d3.js",
    "revision": "63abdde8e734924d7db73f11bfa55401"
  },
  {
    "url": "./ClientApp/public/dist/0.3c0953cba7567a4d24d3.js.map",
    "revision": "93a90cefab36b531252b0b7975bec0bc"
  },
  {
    "url": "./ClientApp/public/dist/1.cbbbae961bc9e26a3969.js",
    "revision": "ff076d0d1a67f74d6c334def1ac3c13c"
  },
  {
    "url": "./ClientApp/public/dist/1.cbbbae961bc9e26a3969.js.map",
    "revision": "2696abea5a2125f0d7cc536c07882519"
  },
  {
    "url": "./ClientApp/public/dist/10.f65e6c7ae7d583e75201.js",
    "revision": "0dc368682981a36fad85ac8105f9aba5"
  },
  {
    "url": "./ClientApp/public/dist/10.f65e6c7ae7d583e75201.js.map",
    "revision": "68a6ae00101af41c6858a2c64acf2514"
  },
  {
    "url": "./ClientApp/public/dist/11.16a8ae69892f6734b9b5.js",
    "revision": "8cb35ceca31867268ace73d706e178c6"
  },
  {
    "url": "./ClientApp/public/dist/11.16a8ae69892f6734b9b5.js.map",
    "revision": "d66e736781f240145cfb5c814d7c4aec"
  },
  {
    "url": "./ClientApp/public/dist/12.3e4a8dc554488fa2d1d1.js",
    "revision": "3b0a7ba67e8dba3d20a12fdadfd37fb6"
  },
  {
    "url": "./ClientApp/public/dist/12.3e4a8dc554488fa2d1d1.js.map",
    "revision": "6f04eb3403097641cddaf43a257da7c8"
  },
  {
    "url": "./ClientApp/public/dist/13.39b92a3d64d07e32e780.js",
    "revision": "ebc254ded6c25fdce4aea8720da7a23a"
  },
  {
    "url": "./ClientApp/public/dist/13.39b92a3d64d07e32e780.js.map",
    "revision": "2e6496c83a245c7221fca5ec2ba7a741"
  },
  {
    "url": "./ClientApp/public/dist/14.fdcadfc1f56997f7b103.js",
    "revision": "e8d79470a68940102dec836ba2ae2932"
  },
  {
    "url": "./ClientApp/public/dist/14.fdcadfc1f56997f7b103.js.map",
    "revision": "2372c92686b597c518c29daa9720eb2a"
  },
  {
    "url": "./ClientApp/public/dist/15.6f0355d792fbf4f03620.js",
    "revision": "5bc9afaea5777d26c8397ef21ae93ba0"
  },
  {
    "url": "./ClientApp/public/dist/15.6f0355d792fbf4f03620.js.map",
    "revision": "c9568950b1968909cb7a31fd2a91384e"
  },
  {
    "url": "./ClientApp/public/dist/16.3f5f6f60aa9eecc513f4.js",
    "revision": "5fec445350697deb4919707de8e2ee0b"
  },
  {
    "url": "./ClientApp/public/dist/16.3f5f6f60aa9eecc513f4.js.map",
    "revision": "cb6e5a1ac20bec841c65860d8924f032"
  },
  {
    "url": "./ClientApp/public/dist/17.7641625fd4cbd548f421.js",
    "revision": "192a44dd7e516498e82e7e12d47a63f6"
  },
  {
    "url": "./ClientApp/public/dist/17.7641625fd4cbd548f421.js.map",
    "revision": "39846666a673a69432b6f48d92f79663"
  },
  {
    "url": "./ClientApp/public/dist/18.1eafa25487b414706635.js",
    "revision": "a4888477ca1a7a1f11d0519009413377"
  },
  {
    "url": "./ClientApp/public/dist/18.1eafa25487b414706635.js.map",
    "revision": "5fb9ff389c1d258a5a836935305ace88"
  },
  {
    "url": "./ClientApp/public/dist/19.1e7c6082749c608ebca5.js",
    "revision": "ba811effb1f7c7bf54e527095ec4b740"
  },
  {
    "url": "./ClientApp/public/dist/19.1e7c6082749c608ebca5.js.map",
    "revision": "c045007e6293f47d8a6156ac17780102"
  },
  {
    "url": "./ClientApp/public/dist/2.02d25b6c07375caa3e4b.js",
    "revision": "abc72acd3766b1d7995ef27d5f66e718"
  },
  {
    "url": "./ClientApp/public/dist/2.02d25b6c07375caa3e4b.js.map",
    "revision": "39f97e0f105f8703f8900f5ff5e6f94e"
  },
  {
    "url": "./ClientApp/public/dist/20.3208e4f0987750e9a6a6.js",
    "revision": "b161625ae28f7a3dc1da8df645209e3d"
  },
  {
    "url": "./ClientApp/public/dist/20.3208e4f0987750e9a6a6.js.map",
    "revision": "6d75bac0ff4fc44a7abe2c6217f102d8"
  },
  {
    "url": "./ClientApp/public/dist/21.a92d3cee3923e109665a.js",
    "revision": "dc941eaef9b059afc9a2dbdf2077fe70"
  },
  {
    "url": "./ClientApp/public/dist/21.a92d3cee3923e109665a.js.map",
    "revision": "79ddc8bad516e7f2ee00821566b3a407"
  },
  {
    "url": "./ClientApp/public/dist/22.fda7cf5c07bffaaf9aab.js",
    "revision": "1e4f33c9e6f1c9f906b23e3223b312f8"
  },
  {
    "url": "./ClientApp/public/dist/22.fda7cf5c07bffaaf9aab.js.map",
    "revision": "48e31d376b724b257d2a4866d1866119"
  },
  {
    "url": "./ClientApp/public/dist/23.b139cf83358d5f3b97a7.js",
    "revision": "dc79bcf946b167f55be2f4cbd493f3ee"
  },
  {
    "url": "./ClientApp/public/dist/23.b139cf83358d5f3b97a7.js.map",
    "revision": "d0b86b4f07d5b913ce2552a78b4cf04a"
  },
  {
    "url": "./ClientApp/public/dist/24.3d8eb2560e0380478462.js",
    "revision": "ffdc71c0b35e35c31a900e93454b479e"
  },
  {
    "url": "./ClientApp/public/dist/24.3d8eb2560e0380478462.js.map",
    "revision": "f907d9568fd63b26552df5d6db026d35"
  },
  {
    "url": "./ClientApp/public/dist/25.9d5a973b1c7e570235c2.js",
    "revision": "f2f7b3fa9dc0f0178ccc10c2332b697b"
  },
  {
    "url": "./ClientApp/public/dist/25.9d5a973b1c7e570235c2.js.map",
    "revision": "61f8f73c2adbf84b2c1a3084b3db5338"
  },
  {
    "url": "./ClientApp/public/dist/26.33f1cf218b3102d08526.js",
    "revision": "265f54f9fe934bd6ab346f47b892c2a2"
  },
  {
    "url": "./ClientApp/public/dist/26.33f1cf218b3102d08526.js.map",
    "revision": "bd5093295e039724825b0bf970009d99"
  },
  {
    "url": "./ClientApp/public/dist/27.bd5c6ba13089e0226cee.js",
    "revision": "103fdb6090b8da92a84e6294155be8a0"
  },
  {
    "url": "./ClientApp/public/dist/27.bd5c6ba13089e0226cee.js.map",
    "revision": "42459a85601683b2619d6c0dd5eedd0a"
  },
  {
    "url": "./ClientApp/public/dist/28.5ab2c3f339c9006a7e53.js",
    "revision": "5bf09f6d8e9b751ae73a417a309d2b1d"
  },
  {
    "url": "./ClientApp/public/dist/28.5ab2c3f339c9006a7e53.js.map",
    "revision": "0e9674350ee9412b38a4e9c08912f302"
  },
  {
    "url": "./ClientApp/public/dist/29.81966bac0e50c92e8e87.js",
    "revision": "a7798ec3e83e3fc3d1663470978224fd"
  },
  {
    "url": "./ClientApp/public/dist/29.81966bac0e50c92e8e87.js.map",
    "revision": "95a6d8e21a2da5ff04ef9efa8b543861"
  },
  {
    "url": "./ClientApp/public/dist/3.46ad793cbdd9a85f7eba.js",
    "revision": "9800128f8c18a719f3fd99be26735d2b"
  },
  {
    "url": "./ClientApp/public/dist/3.46ad793cbdd9a85f7eba.js.map",
    "revision": "b07b5e8881610d08be4c2d3e842072e0"
  },
  {
    "url": "./ClientApp/public/dist/30.1bae627e3be1b8b96535.js",
    "revision": "9405b1a6b96b497245a538db17a281ef"
  },
  {
    "url": "./ClientApp/public/dist/30.1bae627e3be1b8b96535.js.map",
    "revision": "27c84d089a98dd080d2b270f27ca6083"
  },
  {
    "url": "./ClientApp/public/dist/4.95a5c0b987f86a463257.js",
    "revision": "54b41405be1d3a33e2d0112f9e4aca6c"
  },
  {
    "url": "./ClientApp/public/dist/4.95a5c0b987f86a463257.js.map",
    "revision": "0b180e37c594bdf6376b3bd699093935"
  },
  {
    "url": "./ClientApp/public/dist/5.5268e35b55f29ab83d44.js",
    "revision": "9afd561b17869068b383388eb3b045e2"
  },
  {
    "url": "./ClientApp/public/dist/5.5268e35b55f29ab83d44.js.map",
    "revision": "9fa5d3f0656a1d572f3545905af0eb17"
  },
  {
    "url": "./ClientApp/public/dist/6.700a6088304136ec356a.js",
    "revision": "8885c65777bf5e2eaa0c65da25eee5a1"
  },
  {
    "url": "./ClientApp/public/dist/6.700a6088304136ec356a.js.map",
    "revision": "65011b7dbea41c892aeb9cc302103806"
  },
  {
    "url": "./ClientApp/public/dist/7.ad6e5030bb58d4cee9ae.js",
    "revision": "5777a79e7da383cd3c22d0a8ab20f2e0"
  },
  {
    "url": "./ClientApp/public/dist/7.ad6e5030bb58d4cee9ae.js.map",
    "revision": "b0d076192dfcf09901fedd2e5b8ba271"
  },
  {
    "url": "./ClientApp/public/dist/app.8fc634e6ecb2eb06fa88.js",
    "revision": "9213939b55d84b2afc3f3dc611649cef"
  },
  {
    "url": "./ClientApp/public/dist/app.8fc634e6ecb2eb06fa88.js.map",
    "revision": "936e11315a36603812a702079fc2dc3b"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.e8d925c828d363c90058.js",
    "revision": "dd0c242d2e204c17fcef3d7177d9e364"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.e8d925c828d363c90058.js.map",
    "revision": "40ab220cf71b9d28cf853606229e2510"
  }
], {});








